let showError = null;

export const setGlobalShowError = (fn) => {
    showError = fn;
};

export const getGlobalShowError = () => showError;